import * as React from "react";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import { useLocation, Link as RouterLink } from "react-router-dom";
import { Box } from "@mui/material";
import { useFeatureFlag } from "@harnessio/ff-react-client-sdk";
import { useSelector } from "react-redux";

function Copyright(props) {
  return (
    <Typography
      sx={{ fontSize: { xs: 14, md: 19 }, color: "#727272" }}
      {...props}
    >
      {"Copyright © "} {new Date().getFullYear()}{" "}
      <Link
        color="inherit"
        href={"https://vucaware.com/"}
        sx={{ cursor: "pointer" }}
        target="_blank"
      >
        Vucaware
      </Link>{" "}
      {/* {"."} */}
    </Typography>
  );
}

export default function FooterComponent(props) {
  const location = useLocation();
  const flagValue = useFeatureFlag("vucaware_logo_display");
  const footerLinks = useSelector(
    (state) => state.appConfiguration?.footerLinks ?? []
  ).filter((item) => item.key !== "widget");

  const social = [
    {
      title: "Facebook",
      icon: (
        <img
          src="../../../assets/images/fb-footer-icon.svg"
          style={{ width: "100%", height: "100%" }}
          alt="youtube"
          loading="lazy"
        />
      ),
      link: "https://www.facebook.com/TrueSelfy",
    },
    {
      title: "Linkdin",
      icon: (
        <img
          src="../../../assets/images/li-footer-icon.svg"
          style={{ width: "100%", height: "100%" }}
          alt="youtube"
          loading="lazy"
        />
      ),
      link: "https://www.linkedin.com/showcase/trueselfy/",
    },
  ];

  return (
    <Grid
      container
      spacing={{ xs: 1.5, md: 2 }}
      display={"flex"}
      flexDirection="row"
      justifyContent="space-between"
      // alignItems={"center"}
      p={{
        xs: "0px 20px",
        sm: "0px 50px",
        md: "0px 50px",
        lg: "0px 80px",
        xl: "0px 120px",
      }}
      sx={{ pb: { xs: 0, md: 3, lg: "20px !important" }, pt: 3 }}
    >
      <Grid
        item
        lg={6}
        md={5}
        xs={12}

        // sx={{ gap: { xs: "20px", md: "0px" } }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: { xs: 1, md: 2, lg: 4 },
            justifyContent: {
              xs: "center",
              md: "center",
              lg: "center",
              xl: "flex-start",
            },
          }}
        >
          {flagValue ? (
            <>
              <Link
                href="https://vucaware.com"
                target="_blank"
                sx={{ textDecoration: "none" }}
              >
                <img
                  src="../../../assets/images/vucawarelogo.png"
                  alt="vucaware-logo"
                  height="100px"
                  loading="lazy"
                />
              </Link>
            </>
          ) : (
            <></>
          )}
          {footerLinks.map((item, index) => {
            const isInternal = item.link?.startsWith("/");
            const isCurrentRoute =
              isInternal && location.pathname === item.link;
            if (isCurrentRoute) return null;

            const linkSx = {
              color: "#727272",
              fontSize: { xs: 14, md: 19 },
              cursor: "pointer",
              "&:hover": { color: "#26801E" },
            };

            if (isInternal) {
              return (
                <Link
                  component={RouterLink}
                  to={item.link}
                  key={item.key || index}
                  sx={linkSx}
                >
                  {item.label}
                </Link>
              );
            }
            return (
              <Link
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                key={item.key || index}
                sx={linkSx}
              >
                {item.label}
              </Link>
            );
          })}
          {location.pathname !== "/changelog" && (
            <Link
              component={RouterLink}
              to="/changelog"
              sx={{
                color: "#727272",
                fontSize: { xs: 14, md: 19 },
                cursor: "pointer",
                "&:hover": { color: "#26801E" },
              }}
            >
              Changelog
            </Link>
          )}
        </Box>
      </Grid>
      <Grid
        item
        // display={"flex"}
        // flexDirection={{ xs: "column", sm: "column", md: "row" }}
        // alignItems={"center"}
        // justifyContent={"center"}
        // spacing={{ xs: 2, md: 0 }}
        // sx={{ gap: "20px" }}
        sx={{ mb: { xs: "12px", sm: "12px", md: "0px", lg: "0px", xl: "0px" } }}
        lg={6}
        md={7}
        xs={12}
      >
        <Box
          sx={{
            display: "flex",
            flexWrap: { xs: "wrap", sm: "no-wrap" },
            gap: {xs:1,md:2},
            justifyContent: {
              xs: "center",
              md: "center",
              lg: "flex-end",
              xl: "flex-end",
            },
            alignItems: "center",
          }}
          flexDirection={{ xs: "column", md: "column", lg: "row", xl: "row" }}
        >
          <Copyright />

          {/* <Grid
            item
            xs={12}
            lg={6}
            sm={6}
            md={6}
            justifyContent="flex-end"
            display={"flex"}
          > */}
          {/* </Grid> */}
          {/* <Grid
            xs={12}
            lg={6}
            sm={6}
            md={6}
            display={"flex"}
            flexDirection="row"
            alignItems={"center"}
            justifyContent="space-evenly"
            item
            gap={"20px"}
          > */}
          <Box
            sx={{
              display: "flex",
              gap: { xs:1,md:2},
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {social.map((item, index) => (
              <Link
                href={item?.link}
                target="_blank"
                sx={{
                  cursor: "pointer",
                  width: { xs: 30, md: 41 },
                  height: { xs: 30, md: 41 },
                  "&:hover": {
                    filter: "brightness(0.2)", // You can adjust the brightness for hover effect
                  },
                }}
                key={index}
              >
                {item.icon}
              </Link>
            ))}
          </Box>

          {/* </Grid> */}
        </Box>
      </Grid>
    </Grid>
  );
}
